import { DeviceMobile } from '@phosphor-icons/react';

export default DeviceMobile;